export enum EGame {
  QUIZ = "QUIZ",
  CLICK_THE_PIC = "CLICKTHEPIC",
  NOTSET = "NOTSET"
}
